import $ from 'jquery';

// const config = require('../../config/site.config');

/**
 * GoogleAnalytics - Class for collecting analytics data. It stores
 * necessary info in a window object that is later on used by 3rd party
 * to collect and analyze statistics data
 */
export default class GoogleAnalytics {
  constructor() {
    // 3rd party required us to store all data in window dataLayer object
    window.dataLayer = window.dataLayer || [];
    this.dataLayer = window.dataLayer || [];
    this.gaObjects = $('[data-ga-type]');
    this.bodyRef = $('body');
    this.quizName = '';
  }

  /**
   * Initialize articles API
   */
  init() {
    /**
     * Redirection to specified URL
     * @param {String} url - URL where redirect should be
     * @param {String} target - Attribute represent link redirection type "_blank", "_self" etc.
     */
    const redirectToLink = (url, target) => {
      const a = document.createElement('a');
      if (target) {
        a.target = target;
      }
      a.href = url;
      a.click();
    };

    this.bodyRef.ready(() => {
      const productPage = this.bodyRef.find('.js-product_detail_page').length;
      if (productPage) {
        const currentTarget = this.bodyRef.find('.js-product_detail_page').first();
        const singleItemId = currentTarget.data('ga-id');
        const singleItemName = currentTarget.data('ga-label');
        this.dataLayer.push({
          event: 'ga4_view_product',
          ga4_data: {
            single_item_id: singleItemId,
            single_item_name: singleItemName,
          },
        });
      }

      const orderConfirmationPage = this.bodyRef.find('.js-order_confirmation_page').length;
      if (orderConfirmationPage) {
        const currentTarget = this.bodyRef.find('.js-order_confirmation_page').first();
        const items = this.bodyRef.find('.js-order_confirmation_item');
        const itemsList = [];

        items.each((index, element) => {
          const item = $(element);
          const itemData = {
            item_id: item.data('ga-id'),
            item_name: item.data('ga-name'),
            coupon: item.data('ga-coupon'),
            currency: item.data('ga-currency'),
            discount: item.data('ga-discount'),
            index: item.data('ga-index'),
            item_variant: item.data('ga-variant'),
            price: item.data('ga-price'),
            quantity: item.data('ga-quantity'),
            points_value: item.data('ga-points'),
            codes_value: item.data('ga-codes'),
          };
          itemsList.push(itemData);
        });

        this.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: currentTarget.data('ga-transaction-id'),
            value: currentTarget.data('ga-value'),
            tax: currentTarget.data('ga-tax'),
            shipping: currentTarget.data('ga-shipping'),
            currency: currentTarget.data('ga-currency'),
            coupon: currentTarget.data('ga-coupon'),
            points_value: currentTarget.data('ga-points'),
            codes_value: currentTarget.data('ga-codes'),
            items: itemsList,
          },
        });
      }
    });

    // Social share buttons
    this.bodyRef.on('click', '.social-share-btn, .article-buttons .facebook-button, .article-text__share-button', (event) => {
      const currentTarget = $(event.currentTarget);
      this.dataLayer.push({
        event: 'ga4_share',
        ga4_data: {
          method: currentTarget.data('type') === 'copy' ? 'Copy link' : currentTarget.data('type'), // Social Media platform name or “Copy link”
        },
      });
    });

    // DataLayer for quiz
    this.bodyRef.on('click', '.lb-quiz__button', (event) => {
      const button = $(event.currentTarget);
      if (button.closest('.lb-quiz__inner--framed') !== null) {
        this.quizName = 'Libero quiz';
        this.dataLayer.push({
          event: 'ga4_quiz',
          ga4_data: {
            action_type: 'Start quiz',
            label: this.quizName,
          },
        });
      } else {
        this.dataLayer.push({
          event: 'ga4_quiz',
          ga4_data: {
            action_type: 'Retake quiz',
            label: this.quizName,
          },
        });
      }
    });

    this.bodyRef.on('click', '.lb-quiz-navigation__button--next', (event) => {
      const currentTarget = $(event.currentTarget);
      const buttonText = currentTarget.data('index');
      if (buttonText === 'done') {
        this.dataLayer.push({
          event: 'ga4_quiz',
          ga4_data: {
            action_type: 'Completed quiz',
            label: this.quizName,
          },
        });
      }
    });

    this.bodyRef.on('click', '.lb-quiz-share-button', () => {
      this.dataLayer.push({
        event: 'ga4_quiz',
        ga4_data: {
          action_type: 'Share quiz',
          label: this.quizName,
        },
      });
    });

    // DataLayer for all a tag clicks
    document.addEventListener('click', (e) => {
      const linkElement = e.target.closest('a');
      let target = null;
      if (linkElement) {
        target = linkElement.getAttribute('target');
      }
      if (linkElement && !linkElement.classList.contains('modal-trigger') && !linkElement.classList.contains('offer-button')
      && !linkElement.classList.contains('pr-snippet-write-review-link') && !($(linkElement).data('type') === 'copy')) {
        e.preventDefault();
        if (!linkElement.href.includes('void(0)') && !linkElement.href.includes(`/${window.location.host}`)) {
          this.dataLayer.push({
            event: 'ga4_click',
            ga4_data: {
              link_url: linkElement.href,
              link_domain: window.location.origin,
              link_text: linkElement.textContent ? linkElement.textContent : linkElement.ariaLabel,
              outbound: true,
            },
          });
        }
        redirectToLink(
          linkElement.href,
          target,
        );
      }
    });

    // Hero banner swiper links
    const swiperLink = $('.swiper-content a');

    swiperLink.on('click', (event) => {
      event.preventDefault();
      const currentTarget = $(event.currentTarget);
      const ctaButton = currentTarget.find('button');
      this.dataLayer.push({
        event: 'ga4_select_promotion',
        ga4_data: {
          creative_name: 'Hero Banner',
          promotion_name: ctaButton.text(),
        },
      });

      redirectToLink(
        currentTarget.attr('href'),
        currentTarget.attr('target'),
      );
    });

    const relatedArticle = $('.related-articles .article-box__link');
    relatedArticle.on('click', (event) => {
      event.preventDefault();
      const currentTarget = $(event.currentTarget);
      const articleInfo = currentTarget.find('.article-box__container');
      this.dataLayer.push({
        event: 'ga4_select_promotion',
        ga4_data: {
          creative_name: 'Article box',
          promotion_name: articleInfo.text().replace(/\s{2,}/g, ' ').trim(),
        },
      });

      redirectToLink(
        currentTarget.attr('href'),
        currentTarget.attr('target'),
      );
    });

    // Search Page
    const searchPage = $('.search-results');
    if (searchPage.length) {
      this.dataLayer.push({
        event: 'ga4_view_search_results',
        ga4_data: {
          search_term: searchPage.data('searchTerms'), // the term that was written by the user in the search bar
          search_results_count: parseInt(searchPage.data('searchResults'), 10), // this is a variable (integer) that represents the number of total search results (e.g. sum products, articles) displayed
        },
      });
    }

    this.bodyRef.on('click', '.search-results__list .category-item', (event) => {
      event.preventDefault();
      const currentTarget = $(event.currentTarget);
      const searchItemTitle = currentTarget.find('.category-headline');
      const link = document.createElement('a');
      link.href = currentTarget.attr('href'); // converting relative to absolute path

      this.dataLayer.push({
        event: 'ga4_select_search_result',
        ga4_data: {
          search_term: searchPage.data('searchTerms'),
          search_results_count: parseInt(searchPage.data('searchResults'), 10),
          link_url: link.href,
          link_text: searchItemTitle.text(),
          index: currentTarget.index(),
        },
      });

      redirectToLink(
        currentTarget.attr('href'),
        currentTarget.attr('target'),
      );
    });

    // Offers
    this.bodyRef.on('click', '.offer-button', (event) => {
      const offer = $(event.currentTarget);
      const articleTitle = offer.find('.article__headline');
      this.dataLayer.push({
        event: 'ga4_offer',
        ga4_data: {
          action_type: 'Open offer', // this is a variable that should return one of the following: “Open offer” or “Go to offer”
          label: articleTitle.text(), // this is a variable that should return the name of the offer
        },
      });
    });

    this.bodyRef.on('click', '.btn--offer', (event) => {
      const offer = $(event.currentTarget);
      // const articleTitle = offer.parent().parent().find('.offer__title');
      const articleTitle = offer.parentElement.parentElemento.getElementsByClassName('offer__title')[0].innerHTML;
      this.dataLayer.push({
        event: 'ga4_offer',
        ga4_data: {
          action_type: 'Go to offer', // this is a variable that should return one of the following: “Open offer” or “Go to offer”
          label: articleTitle, // this is a variable that should return the name of the offer
        },
      });
    });

    // Reviews
    this.bodyRef.on('click', '.pr-snippet-write-review-link', () => {
      const reviewSnippet = $('#pr-reviewsnippet');
      const productId = reviewSnippet.data('pr-page_id');
      const productName = $('.product-info__headline').text();
      this.dataLayer.push({
        event: 'ga4_review',
        ga4_data: {
          action_type: 'Write a review cta click',
          single_item_id: productId,
          single_item_name: productName,
        },
      });
    });

    this.bodyRef.on('keyup', 'input, textarea', (event) => {
      const field = $(event.currentTarget);
      const form = $('.pr-war');
      let changed = false;
      form.find('.pr-form-control').each((index, element) => {
        if ($(element).data('changed')) {
          changed = true;
        }
      });
      if (!changed) {
        const reviewSnippet = $('#pr-reviewsnippet');
        const productId = reviewSnippet.data('pr-page_id');
        const productName = $('.product-info__headline').text();
        this.dataLayer.push({
          event: 'ga4_review',
          ga4_data: {
            action_type: 'Start to write a review',
            single_item_id: productId,
            single_item_name: productName,
          },
        });
        field.data('changed', true);
      }
    });

    this.bodyRef.on('click', '.pr-war button[type="submit"]', () => {
      const reviewSnippet = $('#pr-reviewsnippet');
      const productId = reviewSnippet.data('pr-page_id');
      const productName = $('.product-info__headline').text();
      this.dataLayer.push({
        event: 'ga4_review',
        ga4_data: {
          action_type: 'Submit a review',
          single_item_id: productId,
          single_item_name: productName,
        },
      });
    });

    // Retailers
    this.bodyRef.on('click', '.col-retail-outlet a', (event) => {
      const button = $(event.currentTarget);
      const gaObjectLabel = button.getAttribute('aria-label');
      const productName = $('.product-name').text();
      this.dataLayer.push({
        event: 'ga4_buy_now_go_to_retailer',
        ga4_data: {
          retailer: gaObjectLabel,
          single_item_name: productName,
          single_item_id: '',
        },
      });
    });

    // Google Analytics
    if (this.gaObjects.length > 0) {
      const self = this;
      this.gaObjects.on('click', (event) => {
        const currentTarget = $(event.currentTarget);
        const gaObjectType = currentTarget.data('ga-type');

        switch (gaObjectType) {
        case 'Article': {
          const gaObjectLabel = currentTarget.data('ga-label');
          self.dataLayer.push({
            event: 'ga4_select_promotion',
            ga4_data: {
              creative_name: 'Article box',
              promotion_name: gaObjectLabel,
            },

          });
          break;
        }
        case 'Product': {
          event.preventDefault();
          const singleItemId = currentTarget.data('ga-id');
          const singleItemName = currentTarget.data('ga-label');
          const linkText = currentTarget.text();
          // const linkUrl = `${window.location.origin}${path.sep}${currentTarget.attr('href')}`;
          const linkUrl = new URL(currentTarget.attr('href'), window.location.origin).toString();
          self.dataLayer.push({
            event: 'ga4_product_click',
            ga4_data: {
              single_item_id: singleItemId,
              single_item_name: singleItemName,
              link_text: linkText,
              link_url: linkUrl,
            },
          });
          redirectToLink(
            currentTarget.attr('href'),
            currentTarget.attr('target'),
          );
          break;
        }
        case 'BIN': {
          event.preventDefault();
          const gaObjectLabel = currentTarget.data('ga-label');
          const gaObjectAction = currentTarget.data('ga-action');

          self.dataLayer.push({
            event: 'ga4_buy_now_go_to_retailer',
            ga4_data: {
              retailer: gaObjectLabel,
              single_item_name: gaObjectAction,
              single_item_id: '',
            },
          });
          redirectToLink(
            currentTarget.attr('href'),
            currentTarget.attr('target'),
          );
          break;
        }

        default:
          break;
        }
      });
    }
  }
}
